import axios from "axios";

class SearchDocs {
  constructor() {
    this.resultsDiv = document.querySelector("#documents");
    this.searchOverlay = document.querySelector(".search-overlay");
    this.searchField = document.querySelector(".toggle-button.active");
    this.isOverlayOpen = false;
    this.isSpinnerVisible = false;
    this.previousValue;
    this.typingTimer;
    this.events();
    this.loadInitialResults();
  }

  events() {
    const buttons = document.querySelectorAll(".toggle-button");
    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        const slug = button.dataset.slug;
        const searchTerm = button.dataset.search;

        console.log("Filtering by category - Name:", searchTerm, "Slug:", slug);
        this.typingLogic(slug);
      });
    });
  }

  loadInitialResults() {
    const firstButton = document.querySelector(".toggle-button");
    if (firstButton) {
      const slug = firstButton.dataset.slug;
      console.log("Loading initial category:", slug);
      this.typingLogic(slug);
    }
  }

  typingLogic(slug) {
    if (slug != this.previousValue) {
      clearTimeout(this.typingTimer);

      if (slug) {
        if (!this.isSpinnerVisible) {
          this.resultsDiv.innerHTML = '<div class="spinner-loader"></div>';
          this.isSpinnerVisible = true;
        }
        this.typingTimer = setTimeout(() => this.getResults(slug), 750);
      } else {
        this.resultsDiv.innerHTML = "";
        this.isSpinnerVisible = false;
      }
    }

    this.previousValue = slug;
  }

  async getResults(slug) {
    try {
      console.log("Fetching documents for category slug:", slug);
      const apiUrl = universityData.root_url + "/wp-json/university/v2/search?term=" + encodeURIComponent(slug);
      console.log("API URL:", apiUrl);

      const response = await axios.get(apiUrl);
      const results = response.data;

      console.log("API Response:", results);
      console.log("Documents found:", results.dokumentumok ? results.dokumentumok.length : 0);

      if (window.location.href.includes("/dokumentumok/")) {
        this.renderDokumentumok(results.dokumentumok || []);
      } else {
        this.renderVizsgahelyek(results.vizsgahelyek || []);
      }

      this.isSpinnerVisible = false;
    } catch (e) {
      console.error("API Error:", e);
      this.resultsDiv.innerHTML = `<p>Hiba történt a keresés során. Kérjük, próbálja újra.</p>`;
      this.isSpinnerVisible = false;
    }
  }

  renderDokumentumok(dokumentumok) {
    this.resultsDiv.innerHTML = `
      <div class="one-full">
        <h2 class="search-overlay__section-title">Dokumentumok</h2>
        ${
          dokumentumok.length
            ? ""
            : `<p>Nem találtunk dokumentumot ebben a kategóriában. <a href="${universityData.root_url}/dokumentumok">Minden dokumentum megtekintése</a></p>`
        }
        ${dokumentumok
          .map(
            (item) => `
          <div class="dokumentum-summary">
            <div class="event-summary__content">
              <h5 class="event-summary__title headline headline--tiny mt-3">${item.title}</h5>
              <p>${item.content}</p>
              <button class="btn-secondary bg-orange pill white mb-2">
                <a href="${item.link}" class="nu white">Letölthető dokumentum</a>
              </button>
            </div>
          </div>
        `
          )
          .join("")}
      </div>
    `;
  }

  renderVizsgahelyek(vizsgahelyek) {
    // Sort vizsgahelyek based on custom conditions
    vizsgahelyek.sort((a, b) => {
      const isElteOrigóNyelviCentrumA = a.title.includes("ELTE Origó Nyelvi Centrum");
      const isElteOrigóNyelviCentrumB = b.title.includes("ELTE Origó Nyelvi Centrum");

      if (isElteOrigóNyelviCentrumA && !isElteOrigóNyelviCentrumB) {
        return -1;
      } else if (!isElteOrigóNyelviCentrumA && isElteOrigóNyelviCentrumB) {
        return 1;
      }

      return a.title.localeCompare(b.title);
    });

    this.resultsDiv.innerHTML = `
      <div class="one-full">
        <h2 class="search-overlay__section-title">Vizsgahelyek</h2>
        ${
          vizsgahelyek.length
            ? ""
            : `<p>Nem találtunk vizsgahelyet ebben a kategóriában. <a href="${universityData.root_url}/vizsgahelyek">Minden vizsgahely megtekintése</a></p>`
        }
        ${vizsgahelyek
          .map(
            (item) => `
          <div class="dokumentum-summary">
            <div class="event-summary__content">
              <h5 class="event-summary__title headline headline--tiny mt-3">${item.title}</h5>
              <p>${item.content}</p>
            </div>
          </div>
        `
          )
          .join("")}
      </div>
    `;
  }
}

export default SearchDocs;